import React from 'react'

export default function CustomAlert({ type = 'error', children, className = '', style = {} }) {
  const variants = {
    error: {
      backgroundColor: '#f8d7da',
      color: '#842029',
      border: '1px solid #f5c2c7',
    },
    // you can add more alert variants here
  }

  const baseStyle = {
    marginTop: '8px',
    padding: '10px 12px',
    borderRadius: '4px',
    fontFamily: 'Roboto',
    ...variants[type],
  }

  return (
    <div role="alert" aria-live="polite" className={className} style={{ ...baseStyle, ...style }}>
      {children}
    </div>
  )
}
